export interface AnalyticsEvent {
  event: string
  [key: string]: unknown
}

export const pushAnalyticsEvent = (analyticsEvent: AnalyticsEvent): void => {
  window.dataLayer = window.dataLayer ?? []
  window.dataLayer.push(analyticsEvent)
}

export function truncateAnalyticsText(value: string, maxLength: number): string {
  const trimmedValue = value.trim().replace(/\s+/g, ' ')

  if (trimmedValue.length <= maxLength) return trimmedValue

  const shortenedValue = trimmedValue.slice(0, maxLength)
  const lastSpaceIndex = shortenedValue.lastIndexOf(' ')

  return (lastSpaceIndex > 0 ? shortenedValue.slice(0, lastSpaceIndex) : shortenedValue).trim()
}
